import * as actions from './actions'
import {Map, fromJS, List} from 'immutable';


function reducer(
        state=Map({
            billing: Map({
                'isFetching': false,
                'hasInfo': false,
                'info': Map()
            }),
            history: Map({
                'isFetching': false,
                'currentPage': 1,
                'pages': Map()
            }),
            invoice: Map({
                'isFetching': false,
                'info': Map()
            }),
            stats: Map({
                'ticketCreated': Map({
                    'isFetching': false,
                    'isFetched': false,
                    'payload': Map()
                }),
                'live': Map({
                    'isFetching': false,
                    'isFetched': false,
                    'payload': Map()

                })
            })
        }),action) {
    switch (action.type) {
        case actions.SET_PAYMENT_STATUS:
            return state.setIn(['info', 'payment_status'], fromJS(action.payload))
        // =========INVOICE ===============
        case actions.INVOICE_READ_REQUEST:
            return state.setIn(['invoice', 'isFetching'], true)
        case actions.INVOICE_READ_FAILURE:
            return state.setIn(['invoice', 'isFetching'], false)
        case actions.INVOICE_READ_SUCCESS:
            return state
                .setIn(['invoice', 'isFetching'], false)
                .setIn(['invoice', 'info'], fromJS(action.payload))
        // ========= BILLING READ ===========
        case actions.BILLING_READ_REQUEST:
            return state.setIn(['billing', 'isFetching'], true)
        case actions.BILLING_READ_FAILURE:
            return state.setIn(['billing', 'isFetching'], false)
        case actions.BILLING_READ_SUCCESS:
            return state
                .setIn(['billing', 'isFetching'], true)
                .setIn(['billing', 'hasInfo'], true)
                .setIn(['billing', 'info'], fromJS(action.payload))
        // ========= COMPANY ============
        case actions.SET_COMPANY_INFO:
            return state.set('info', fromJS(action.payload))
        case actions.UPDATES_SUCCESS:
            for(var key in action.payload){
                state = state.setIn(['info', key], action.payload[key])
            }
            return state;

        case actions.HISTORY_READ_REQUEST:
            return state
                .setIn(['history', 'isFetching'], true)
                .setIn(['history', 'currentPage'], action.currentPage)

        case actions.HISTORY_READ_SUCCESS:
            return state
                .setIn(['history', 'count'], action.count)
                .setIn(['history', 'isFetching'], false)
                .updateIn(['history', 'pages'],(map) => map.set(action.page, fromJS(action.payload)))
        case actions.HISTORY_READ_FAILURE:
            return state.setIn(['history', 'isFetching'], false)
        // STATS
        case actions.STATS_TICKET_CREATED_REQUEST:
            return state.setIn(['stats', 'ticketCreated', 'payload'], List())
        case actions.STATS_TICKET_CREATED_SUCCESS:
            return state.setIn(['stats', 'ticketCreated', 'payload'], fromJS(action.stats))
        case actions.STATS_TICKET_RESPONSE_SUCCESS:
            return state.setIn(['stats', 'response', 'payload'], fromJS(action.stats))
        // mannen, i dont fking know.
        case actions.STATS_TICKET_CREATED_ADDITION:
            if(!state.getIn(['stats', 'live', 'payload']).size) return state; // we dont care
            return state.updateIn(['stats', 'ticketCreated', 'payload'], lst => {
                // we have to make sure the index that got update is correct
                // this mean the intervall would corresponding to the if clause
                // below where time_n < current_time < time_n+1   // Tuan
                return lst.map((x, index) => {
                    let currentIndexTime = new Date(x.get('time')).getTime()
                    let currentTime = new Date(action.time).getTime()
                    let nextIndexTime = new Date(lst.getIn([index+1, 'time'], 0)).getTime()
                    if(currentIndexTime <= currentTime && currentTime < nextIndexTime){
                        return x.update('count', x=>x+action.value)
                    }
                    return x
                })
            })

        case actions.STATS_TICKET_RESPONSE_ADDITION:
            if(!state.getIn(['stats', 'live', 'payload']).size) return state; // we dont care
            if(new Date(action.time).getDate() === new Date().getDate()){
                state = state.updateIn(['stats', 'live', 'payload', 'avgs', 0, 'second'], lst=>lst.push(fromJS(action.second)))
            }
            return state.updateIn(['stats', 'response', 'payload'], lst => lst.push(Map({'time': action.time, 'second': fromJS([action.second])})))
        case actions.STATS_LIVE_SUCCESS:
            return state.setIn(['stats', 'live', 'payload'], fromJS(action.stats))
        case actions.STATS_LIVE_UPDATE_NBR:
            if(!state.getIn(['stats', 'live', 'payload']).size) return state; // we dont care
            return state.updateIn(['stats', 'live', 'payload', action.key], value => value + action.value)
        default:
            return state;
      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/Company/reducer.js